import axios from "axios";
import type { AxiosResponse } from "axios";
import { publicApiUrl, signedInApiUrl, MATCH_RESULTS, type MatchResult } from "../util/Constants";
import type { MatchDetail, SetScore } from "../types/domain";

const MATCH_API = "/matches";

export interface MatchResultDto {
  state: MatchResult;
  results: SetScore[];
}

export const matchesApi = {
  getDetail: async (id: number | string): Promise<MatchDetail> => {
    const { data } = await axios.get<MatchDetail>(`${publicApiUrl}${MATCH_API}/${id}/detail`);
    const focusedPlayerId = data.match.playerOne.id;
    data.headToHeadMatches.forEach((match) => {
      match.isWin =
        (match.state === MATCH_RESULTS.PLAYER_ONE_WON && match.playerOne.id === focusedPlayerId) ||
        (match.state === MATCH_RESULTS.PLAYER_TWO_WON && match.playerTwo.id === focusedPlayerId);
    });
    return data;
  },

  like: async (id: number): Promise<AxiosResponse> => {
    return axios.post(`${signedInApiUrl}${MATCH_API}/${id}/like`);
  },

  unlike: async (id: number): Promise<AxiosResponse> => {
    return axios.delete(`${signedInApiUrl}${MATCH_API}/${id}/unlike`);
  },

  /**
   * Set match result. Callers with organize permission (admin/creator/organizer — the tournament
   * detail's `canManage` flag) post to `/result-as-organizer`; participants post to `/result`.
   */
  setResult: async ({ matchId, resultDto, asOrganizer = false }: { matchId: number; resultDto: MatchResultDto; asOrganizer?: boolean }): Promise<unknown> => {
    const endpoint = asOrganizer ? "result-as-organizer" : "result";
    const { data } = await axios.post(`${signedInApiUrl}${MATCH_API}/${matchId}/${endpoint}`, resultDto);
    return data;
  },
};
